import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=21eb321b&scoped=true"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=21eb321b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eb321b",
  null
  
)

export default component.exports